<template>
    <div>
        <modal-box v-model="isEmptyFiltersModalActive" :title="__('Choice')" :button-label="__('Ok')"
                   @confirm="isEmptyFiltersModalActive = false">
            {{ __('You have not selected any stores') }}
        </modal-box>

        <modal-box v-model="isStoresModalActive" :title="__('Choice of stores')" has-cancel @confirm="selectStores">
            <field :label="__('Store')">
                <VueMultiselect
                    v-model="store"
                    :options="store_options"
                    :taggable="false"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="false"
                    :placeholder="__('Select')"
                    :selectLabel="__('Press enter to select')"
                    :selectedLabel="__('Selected')"
                    :deselectLabel="__('Press enter to remove')"
                    label="label"
                    track-by="label"
                    :preselect-first="false">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                        {{ values.length }} options selected</span>
                    </template>
                </VueMultiselect>
            </field>
        </modal-box>

        <div class="relative">
            <jb-buttons class="absolute -top-2 right-0 justify-end">
                <jb-button type="button" small color="info" :icon="mdiPlusBox"
                           @click.prevent="getStoreOptions"/>
                <jb-button type="button" small color="danger" :icon="mdiCloseBoxMultiple"
                           @click.prevent="removeAll()"/>
            </jb-buttons>
            <field :label="__('Choice of stores')">
                <multi-select v-model="computedValue"
                              @clickOnEmptyText="getStoreOptions"
                              @clickOnEmptyField="getStoreOptions"/>
            </field>
        </div>
    </div>
</template>

<script>

import {computed} from 'vue'
import VueMultiselect from 'vue-multiselect'
import Field from '@/Components/Dashboard/Field'
import Control from '@/Components/Dashboard/Control'
import CheckRadioPicker from '@/Components/Dashboard/CheckRadioPicker'
import JbButton from '@/Components/Dashboard/JbButton'
import JbButtons from '@/Components/Dashboard/JbButtons'
import MultiSelect from '@/Components/Dashboard/MultiSelect'
import ModalBox from "@/Components/Dashboard/ModalBox";
import {ref} from "vue";
import {
    mdiPlusBox,
    mdiCloseBoxMultiple
} from "@mdi/js";

export default {
    name: "StoresSelector",
    components: {
        VueMultiselect,
        Field,
        Control,
        CheckRadioPicker,
        JbButton,
        JbButtons,
        MultiSelect,
        ModalBox
    },
    props: {
        site: Object,
        modelValue: {
            type: Array,
            default: []
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            rememberSiteId: null,
            store: [],
            store_options: [],
        }
    },
    setup(props, {emit}) {
        const computedValue = computed({
            get: () => props.modelValue,
            set: value => {
                emit('update:modelValue', value)
            }
        })

        const isEmptyFiltersModalActive = ref(false)
        const isStoresModalActive = ref(false)

        return {
            mdiPlusBox,
            mdiCloseBoxMultiple,
            computedValue,
            isEmptyFiltersModalActive,
            isStoresModalActive,
        }
    },
    methods: {
        getStoreOptions() {
            this.store = []

            if (this.rememberSiteId !== this.site.id) {
                this.store_options = []
            }
            this.rememberSiteId = this.site.id;

            if (this.store_options.length > 0) {
                this.isStoresModalActive = true
                return
            }

            const self = this
            this.getStores().then(response => {
                for (const itemId in response.data) {
                    const item = response.data[itemId]
                    self.store_options.push({id: item.id, label: item.name})
                }
                self.isStoresModalActive = true
            });
        },
        getStores(callback = null) {
            return this.apiRequest('api.v1.stores.index', {'siteId': this.site.api_source_id})
        },
        removeAll() {
            this.computedValue = [];
        },
        pushToStores(element, type = 'store') {
            const search = this.computedValue.find(el => el.type === type && el.id == element.id);
            if (typeof search !== "undefined") {
                return
            }

            if (typeof element.id === "undefined") {
                this.isEmptyFiltersModalActive = true
                return
            }

            this.computedValue.push({
                type: type,
                id: element.id,
                name: element.label
            });
        },
        selectStores() {
            if (this.store.length === 0) {
                this.isEmptyFiltersModalActive = true
                return
            }

            const self = this;

            this.store.forEach(element => {
                self.pushToStores(element, 'store')
            });
            this.store = []
        },
        showLoading() {
            document.body.classList.add('_show_loading');
        },
        hideLoading() {
            document.body.classList.remove('_show_loading');
        },
        apiRequest(route, data) {
            const self = this
            return new Promise((resolve, reject) => {
                self.showLoading()
                axios.post(this.route(route), data).then(response => {
                    self.hideLoading()
                    resolve(response)
                }).catch(error => {
                    self.hideLoading()
                    console.error(error)
                    reject(error)
                });
            });
        },
    }
}
</script>

<style scoped>

</style>
